export interface IClientItem {
  name: string;
  downloadUrl?: string;
  show?: boolean;
  track?: any;
  platform?: string;
  key: string;
  type?: string;
}

export interface IFormItem {
  name: string;
  placeholder: string;
  rules: any[];
  isTextArea?: boolean;
  maxLength?: number;
  className?: string;
}

const qrCode = 'https://devcdn.xylink.com/xylink_website_doc/images/try/%E7%AB%8B%E5%8D%B3%E8%AF%95%E7%94%A82%E5%80%8D%E4%BA%8C%E7%BB%B4%E7%A0%81.png';
const clientList: IClientItem[] = [
  {
    name: '试用Windows客户端',
    platform: 'desktop_pc',
    track: { category: 'Windows下载量-try' },
    key: 'pc',
    show: true,
    type: 'WINDOWS_TRIAL',
  },
  {
    name: '试用Mac客户端',
    platform: 'desktop_mac',
    track: { category: 'Mac下载量-try' },
    key: 'mac',
    show: true,
    type: 'MAC_TRIAL',
  },
  {
    name: '试用Web会议',
    downloadUrl: 'https://cdn.xylink.com/webrtc/web/index.html?number=MTg4MTg4#/',
    track: { category: 'webRTC', action: '试用' },
    key: 'webRTC',
    show: true,
  },
];

const formList: IFormItem[] = [
  {
    name: 'contactName',
    placeholder: '您的姓名',
    rules: [
      {
        required: true,
        message: '请填写您的姓名',
      },
    ],
  },
  {
    name: 'contactPhone',
    placeholder: '联系电话',
    rules: [
      {
        required: true,
        message: '请填写您的联系电话',
      },
      {
        pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
        message: '填写的电话号码格式不正确',
      },
    ],
  },
  {
    name: 'contactEmail',
    placeholder: '您的邮箱',
    rules: [
      {
        required: true,
        message: '请填写您的邮箱',
      },
      {
        type: 'email',
        message: '您填写的邮箱格式不正确',
      },
    ],
  },
  {
    name: 'contactEnterpriseName',
    placeholder: '公司名称',
    rules: [
      {
        required: true,
        message: '请填写您的公司名称',
      },
    ],
  },
  {
    name: 'customerDemand',
    placeholder: '您的需求',
    rules: [
      {
        required: true,
        message: '请填写您的需求',
      },
    ],
    isTextArea: true,
    maxLength: 200,
    className: 'textArea',
  },
];
export { qrCode, clientList, formList };
